// extracted by mini-css-extract-plugin
export default {"survey-container":"styles-module_survey-container---Xf65L"};